import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'

export default class PlanID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
